export default __webpack_public_path__ + "static/media/wrong.b4fa0c52.wav";